export enum StyleBreakPoint {
  SMALL = '@s',
  MIDDLE = '@m',
  LARGE = '@l',
  X_LARGE = '@xl',
}
